Ext.define('SA.ImportTerms', {
    constructor(notice) {
        this.noticeId = notice ? notice.user_notification_id : null;
    },

    didAgree() {
        return this.noticeId === null;
    },

    setDidAgree() {
        SA.model.Notices.acknowledge({id: this.noticeId});

        this.noticeId = null;
    }
});